// src/firebase.js

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { getUrls } from '../src/api/apiurls.js';
// import config from '@/config';

var pushNConfigs = getUrls().pushNotifications;
// Nabeel 
// const firebaseConfig = {
// apiKey: "AIzaSyC9L7ZfzMBm_VF4pvKcQl6tCAraKIbBpbA",
// authDomain: "ebuyings-3a9b1.firebaseapp.com",
// projectId: "ebuyings-3a9b1",
// storageBucket: "ebuyings-3a9b1.appspot.com",
// messagingSenderId: "521126371798",
// appId: "1:521126371798:web:4b5c8f2d1e46b8aec74477",
// measurementId: "G-6SBD9TG2ZC"
// };

// Ahsan
const firebaseConfig = {
  apiKey: pushNConfigs.apiKey,
  authDomain: pushNConfigs.authDomain,
  projectId: pushNConfigs.projectId,
  storageBucket: pushNConfigs.storageBucket,
  messagingSenderId: pushNConfigs.messagingSenderId,
  appId: pushNConfigs.appId,
  measurementId: pushNConfigs.measurementId,
};


// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(firebaseApp);

export const requestForToken = () => {
  //Nabeel
 // return getToken(messaging, { vapidKey: 'BFi2gz6C3XJGnv0EILFQy_XyeyG-IOZw1KCMmjhl5exjQNbwi9NxvzkaUxBp49QJR4GQ3pdKrDVW3vmuSnh0To4' })
   return getToken(messaging, { vapidKey: pushNConfigs.vapidKey })

  .then((currentToken) => {
      if (currentToken) {
        console.log('Current token for client: ', currentToken);
        return currentToken;
        // Send the token to your server and update the UI if necessary
      } else {
        console.log('No registration token available. Request permission to generate one.');
        return null;
      }
    })
    .catch((err) => {
      console.error('An error occurred while retrieving token. ', err);
    });
};
//correct
// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       resolve(payload);
//     });
//   });

// Set up onMessage listener
export const onMessageListener = (callback) => {
  onMessage(messaging, callback);
};